import { NavLink } from 'react-router-dom'
import { Home, Globe, LayoutGrid, Settings } from 'lucide-react'
import type { ComponentType } from 'react'

type Tab = { to: string; label: string; icon: ComponentType<{ size?: number; strokeWidth?: number }> }

const TABS: Tab[] = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/pulse', label: 'Nationwide', icon: Globe },
  { to: '/products', label: 'Products', icon: LayoutGrid },
  { to: '/settings', label: 'Settings', icon: Settings },
]

export function TabBar() {
  return (
    <nav className="tabbar" aria-label="Primary">
      <div className="tabbar-inner">
        {TABS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) => `tab${isActive ? ' tab--active' : ''}`}
          >
            <Icon size={22} strokeWidth={2} />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
